import { SimpleBaseModule } from './mapps/simple-base/simple-base.module';
import { SandboxedGuard } from './auth/sandboxed.guard';
import { NgModule } from '@angular/core';
import { CommonModule, APP_BASE_HREF } from '@angular/common';
import { environment } from 'src/environments/environment';
import { LoginComponent } from './login/login.component';
import { ExtraOptions, RouterModule, Routes, UrlSegment } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LogoutComponent } from './login/logout/logout.component';
import { UnauthGuard } from './auth/unauth.guard';
import { InvalidBrowserComponent } from './invalid-browser/invalid-browser.component';
import { ArcgisConfigComponent } from './mapps/dmi-pages/data/arcgis/arcgis-config/arcgis-config.component';

const routes: Routes = [
  { path: '', redirectTo: '/app_selector', pathMatch: 'full' },
  {
    path: 'tests',
    loadChildren: () => import('./tests/tests.module').then(m => m.TestsModule),
    canActivate: [AuthGuard]
  },
  { path: 'browsers', component: InvalidBrowserComponent },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent, pathMatch: 'full' },
  {
    path: 'public',
    children: [
      { path: '', redirectTo: '/app_selector', pathMatch: 'full' },
      {
        path: 'simple_map',
        loadChildren: () => import('./mapps/simple-map/simple-map.module').then(m => m.SimpleMapModule),
        canActivate: [UnauthGuard]
      },
      {
        path: 'multi_map',
        loadChildren: () => import('./mapps/multi-layer-map/multi-layer-map.module').then(m => m.MultiLayerMapModule),
        canActivate: [UnauthGuard]
      },
      {
        path: 'viewer',
        loadChildren: () => import('./mapps/viewer/viewer.module').then(m => m.ViewerModule),
        canActivate: [UnauthGuard]
      },
      {
        path: 'sl-viewer',
        loadChildren: () => import('./mapps/sl-viewer/sl-viewer.module').then(m => m.SLViewerModule),
        canActivate: [UnauthGuard]
      },
      /*
      {
        path: 'app_selector',
        loadChildren: () => import('./app-selector/app-selector.module').then(m => m.AppSelectorModule)
      },
      */
      { path: 'logout', component: LogoutComponent, pathMatch: 'full' },
      { path: '**', redirectTo: '/app_selector' }

    ]
  },
  {
    path: 'sandboxed',
    children: [
      { path: '', redirectTo: '/app_selector', pathMatch: 'full' },
      {
        path: 'simple_map',
        loadChildren: () => import('./mapps/simple-map/simple-map.module').then(m => m.SimpleMapModule),
        canActivate: [SandboxedGuard]
      },
      {
        path: 'multi_map',
        loadChildren: () => import('./mapps/multi-layer-map/multi-layer-map.module').then(m => m.MultiLayerMapModule),
        canActivate: [SandboxedGuard]
      },
      {
        path: 'viewer',
        loadChildren: () => import('./mapps/viewer/viewer.module').then(m => m.ViewerModule),
        canActivate: [SandboxedGuard]
      },
      {
        path: 'sl-viewer',
        loadChildren: () => import('./mapps/sl-viewer/sl-viewer.module').then(m => m.SLViewerModule),
        canActivate: [SandboxedGuard]
      },
      {
        path: 'simplebase',
        loadChildren: () => import('./mapps/simple-base/simple-base.module').then(m => m.SimpleBaseModule),
        canActivate: [SandboxedGuard]
      },
      /*
      {
        path: 'app_selector',
        loadChildren: () => import('./app-selector/app-selector.module').then(m => m.AppSelectorModule)
      },
      */
      { path: 'logout', component: LogoutComponent, pathMatch: 'full' },
      { path: '**', redirectTo: '/app_selector' }

    ]
  },
  {
    path: 'app_selector',
    children: [
      {
        path: '',
        loadChildren: () => import('./app-selector/app-selector.module').then(m => m.AppSelectorModule),
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'simple_map',
    children: [
      {
        path: '',
        loadChildren: () => import('./mapps/simple-map/simple-map.module').then(m => m.SimpleMapModule),
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'multi_map',
    children: [
      {
        path: '',
        loadChildren: () => import('./mapps/multi-layer-map/multi-layer-map.module').then(m => m.MultiLayerMapModule),
        canActivate: [AuthGuard]
      }
    ]
  }, {
    path: 'viewer',
    children: [
      {
        path: '',
        loadChildren: () => import('./mapps/viewer/viewer.module').then(m => m.ViewerModule),
        canActivate: [AuthGuard]
      }
    ]
  }, {
    path: 'sl-viewer',
    children: [
      {
        path: '',
        loadChildren: () => import('./mapps/sl-viewer/sl-viewer.module').then(m => m.SLViewerModule),
        canActivate: [AuthGuard]
      }
    ]
  }, {
    path: 'dmi-pages',
    children: [
      {
        path: '',
        loadChildren: () => import('./mapps/dmi-pages/dmi-pages.module').then(m => m.DmiPagesModule),
        canActivate: [AuthGuard]
      }
    ]
  }, {
    path: 'data-management',
    children: [
      {
        path: '',
        loadChildren: () => import('./mapps/dmi/dmi.module').then(m => m.DmiModule),
        canActivate: [AuthGuard]
      }
    ]
  }, {
    path: 'simple-base',

    loadChildren: () => import('./mapps/simple-base/simple-base.module').then(m => m.SimpleBaseModule),
    canActivate: [AuthGuard]
  }

];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  declarations: [],
  providers: [
    { provide: APP_BASE_HREF, useValue: environment.baseHref }
  ]
})
export class AppRoutingModule implements ExtraOptions {
  public relativeLinkResolution?: 'legacy' | 'corrected' = 'corrected';

}
